module.exports = __webpack_public_path__ + "f13e328f5c900ad631e3fb70bd96ab22.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg64.jpeg
// module id = 77
// module chunks = 0